import {SvgSexTwoLearnMore, SvgSexOneBLearnMore, SvgSexThreeEnd ,SvgSexOneLearnMore } from "components/Images/sex";

const sexThree = [
      {
        id: 'sex-3-learnmore',
        type: 'learnmore',
        text: '<p>Jamie has indicated that they are not ready for sex. They are enjoying what they&rsquo;ve been doing up until now and are not ready to take it further.</p><p>Having a good relationship doesn&rsquo;t mean you have to have sex. There are many other ways to have a good time and show your partner that you care about them.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage: SvgSexTwoLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>Sex can feel like a big step, so it is important to wait until you feel ready and comfortable to do it. This might be a different time to your friends and peers, and that is ok. Everyone becomes ready in their own time. Check out our page on relationships and things to think about when deciding if you are&nbsp;<a href="https://bodytalk.org.au/relationships/am-i-ready-sex-and-relationships" target="_blank">ready to have sex</a>.</p><p>Whatever you choose to do together, whether it&rsquo;s kissing, touching or having sex, it should always be something that you both want to do.</p><p>Both you and your partner need to feel emotionally and physically ready and sure about your decision to have sex.</p>'
        },
        nextStepId: 'sex-3a',
      },
      {
        id: 'sex-3a',
        type: 'question',
        text: "<p>Amari stops, looks Jamie in the eye and says:",
        backgroundImage: SvgSexTwoLearnMore,
        options: [
          {
            id: 'sex-3a-option-1',
            text: "“Of course, I don’t want you to feel pressure if you're not ready. I’m happy to keep doing what we’ve been doing. I’m having a lot of fun.”",
            icon: '🙂',
            iconBackground: '#fbe9b6',
            nextStepId: 'sex-3a-learnmore'
          },
          {
            id: 'sex-3a-option-3',
            text: "“Come on. We’ve been going out for 4 months. Everyone we know is doing it. Don’t you think it’s time?”",
            icon: '😟',
            iconBackground:'#fbe9b6',
            nextStepId: 'sex-3b-learnmore',
  
          }
        ]
      },
      {
        id: 'sex-3a-learnmore',
        type: 'learnmore',
        text: '<p>Jamie appears to be unsure about whether they are ready to have sex. Both Amari and Jamie need to feel emotionally and physically ready and sure about their decision to have sex.</p><p>No one should feel pressured by their partner to do something they&rsquo;re not ready for.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage:SvgSexTwoLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>It is OK for you to take your time when deciding whether you&rsquo;re ready to have sex. You should make sure you are comfortable and can communicate what you are and are not willing to do.</p><p>Visit <a href="https://bodytalk.org.au/relationships/am-i-ready-sex-and-relationships" target="_blank">Body Talk</a> for more information</p>'
        },
        nextStepId: 'sex-3a-end',
      },
      {
        id: 'sex-3a-end',
        type: 'learnmore',
        text: "<p>Jamie smiles at Amari and says: &ldquo;I&rsquo;m glad we&rsquo;ve started the conversation. Let&rsquo;s keep talking about it. But it doesn&rsquo;t have to be now. I&rsquo;m starving! Let&rsquo;s go back to the festival and get something to eat.&rdquo;</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage:SvgSexOneLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: "<p>Communication is a key part of building and maintaining a respectful, healthy relationship. Communication helps you to make sure you both want and expect the same things, and involves talking and listening to one another.</p>"
        },
        nextStepId: null,
      },
      {
        id: 'sex-3b-learnmore',
        type: 'learnmore',
        text: '<p><p>Amari is trying to pressure Jamie to have sex even though they have said they don&rsquo;t want to. This is not OK - it could actually be considered sexual coercion.</p><p>People have every right to say no and have their boundaries respected.</p>',
        scrollText: "<span>Scroll down</span> for more.",
        backgroundImage:SvgSexOneBLearnMore,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>Being pressured or coerced into any type of sexual act is not a part of the <a href="https://bodytalk.org.au/relationships/respectful-relationships/" target="_blank">healthy, respectful relationship</a>. <br /><br />Sex is all about <a href="https://bodytalk.org.au/relationships/relationships-consent/" target="_blank">consent</a>. If you don&rsquo;t want to have sex, let your partner know.</p><p>If they pressure you or threaten to break up with you because you don&rsquo;t want to have sex or other sexual activity, this is a sign that you&rsquo;re in an <a href="https://bodytalk.org.au/relationships/feeling-safe/" target="_blank">unhealthy relationship</a>.</p><p>If your partner says no to sex, it&rsquo;s really important to respect their decision.</p>'
        },
        nextStepId: 'sex-3b-end',
      },
      {
        id: 'sex-3b-end',
        type: 'learnmore',
        text: "<p>Jamie responds: &ldquo;That&rsquo;s not true. I know plenty of people who aren&rsquo;t having sex. Even if it were true, I don&rsquo;t care what everyone else is doing. I&rsquo;m not ready.&rdquo;</p><p>Amari threatens to break up with Jamie if they don&rsquo;t have sex. Jamie, very upset, says &ldquo;if being together means we have to have sex right now, then I don&rsquo;t think I want to be in a relationship with you. I&rsquo;m going to head back to the festival. I&rsquo;ll stay in Frankie&rsquo;s tent tonight.&rdquo;</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgSexThreeEnd,
        learnmore: {
          title: "More about sex 🤔",
          content: '<p>We all have a right to feel safe and respected in our relationships. It&rsquo;s important to remember that you have a choice to be in any relationship, and the right to leave. Your happiness and safety comes first and staying with someone because you&rsquo;re afraid to be alone, or you&rsquo;re worried about the possible consequences of leaving them, is never a good reason to be with someone.</p><p>If you, or someone you know, are experiencing unhealthy behaviour or abuse there are people who can help you.</p>'
        },
        nextStepId: null,
      },
]



export default sexThree